import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

import { ParamsService } from '../../../../../shared/params.service';
import { Subscription } from 'rxjs';
import { NgClass, DecimalPipe } from '@angular/common';


@Component({
    selector: 'app-lesson-breadcrumb',
    templateUrl: './lesson-breadcrumb.component.html',
    styleUrls: ['./lesson-breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, DecimalPipe]
})
export class LessonBreadcrumbComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  breadCrumbSections = [
    {label: 'Introduction', id: 'introduction'},
    {label: 'Strategy', id: 'strategy'},
    {label: 'Practice', id: 'practice'},
    {label: 'Persistence', id: 'persistence'},
    {label: 'Conclusion', id: 'conclusion'}
  ];

  currentSection: string;


  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private paramsService: ParamsService) {

  }

  ngOnInit() {
    this.setCurrentSection();
    this.subscriptions.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setCurrentSection();
      }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * Get current section to set as active in lesson breadcrumb.
   */
  private setCurrentSection() {
    this.currentSection = this.paramsService.getRouteDataById('breadcrumb',
      this.activatedRoute.snapshot)['currentSection'];
  }

}
